// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".company-description {\n    padding-top: 5px;\n    padding-bottom: 10px;\n}\n\n.company-insights{\n    /*margin-top: 20px;*/\n}\n\n.company-icon{\n    font-size: 15px;\n    margin: 0 15px 0 0;\n}", ""]);
// Exports
module.exports = exports;
